export default "__VITE_ASSET__DfItXJdn__"